module.exports = __webpack_public_path__ + "static/img/test-and-repair.603e5b87.png";